import { useEffect, useState } from "react";

import {
	Avatar,
	Box,
	Button,
	CardActions,
	CardMedia,
	Checkbox,
	Drawer,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	FormLabel,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { Create, getStylistUsers, UpdateGrapeList } from "../../apis/GrapeList";

import { Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "semantic-ui-react";
import { getTags } from "../../apis/Tags";
import { getCurrentUser } from "../../store/authentication/service";
import { ImageCropper } from "../CommonFunctions/ImageCropper";
import FormWrapper from "../Form/FormWrapper";
import { AddGrapeListPopupDialog } from "./AddGrapeListPopupDialog";
import { AddPlayoffProductsDialog } from "./AddPlayoffProductsDialog";
import { AddProductDrawer } from "./AddProductDrawer";
import { useGrapeList } from "./context/GrapeListProvider";
import { DeleteProductDialog } from "./DeleteProductDialog";
export const GrapeListForm = ({ mode = "add", grapeList = null }) => {
	const isEdit = mode === "edit";
	const user = getCurrentUser();
	const navigate = useNavigate();
	const {
		products,
		setProducts,
		handleOpen,
		handlePopupOpen,
		selectedPopup,
		setSelectedPopup,
		requestRemoveProduct,
		initializeProducts,
	} = useGrapeList();

	const [editOpen, setEditOpen] = useState(false);
	const [listOptions] = useState([
		{
			value: "grape_list",
			title: "Grape List",
		},
		{
			value: "stylist_list",
			title: "Stylist List",
		},
	]);
	const [stylelist, setStylelist] = useState([]);
	const [list, setList] = useState([]);

	useEffect(() => {
		_.debounce(async () => {
			const users = await getStylistUsers();
			setStylelist(users);
			const tags = await getTags();
			setList(tags.results);
		}, 500)();
	}, []);

	const handleAdd = () => {
		setEditOpen(true);
	};

	const handleOnChange = (event) => {
		const newImage = event.target?.files?.[0];
		console.log(newImage);
		if (newImage) {
			// console.log(newImage);
			setFilename(newImage.name);
			setImage(URL.createObjectURL(newImage));
			setCrop(true);
		}
	};
	const [filename, setFilename] = useState("");
	const [image, setImage] = useState(null);
	const [crop, setCrop] = useState(false);

	const {
		register,
		handleSubmit,
		watch,
		reset,
		control,
		formState: { errors },
	} = useForm({
		defaultValues: {
			title: "",
			description: "",
			list_category: [],
			list_type: "",
			owner: "",
			products: [],
		},
	});

	useEffect(() => {
		if (!isEdit || !grapeList) {
			return;
		}
		console.log("====================================");
		console.log("yeeeessss");
		console.log("====================================");

		reset({
			title: grapeList.title || "",
			description: grapeList.description || "",
			list_category:
				grapeList.list_category?.map((item) =>
					typeof item === "object" ? item.id : item,
				) || [],
			list_type: grapeList.list_type || "",
			owner:
				typeof grapeList.owner === "object"
					? grapeList.owner?.id
					: grapeList.owner || "",
			products: grapeList.products?.map((item) => item.id) || [],
		});
		initializeProducts(grapeList.products || []);
		setImage(grapeList?.image?.file || null);
		// setSelectedPopup(grapeList.popup || null);
	}, [isEdit, grapeList, reset, initializeProducts]);

	useEffect(() => {
		if (!isEdit || !grapeList) {
			return;
		}

		setSelectedPopup(grapeList.popup || null);
	}, [isEdit, grapeList, setSelectedPopup]);

	// useEffect(() => {
	// 	setValue(
	// 		"products",
	// 		products.map(({ id }) => id),
	// 	);
	// }, [products]);

	const listType = watch("list_type");
	const notify = () =>
		toast.error(`Please select Products`, {
			position: "bottom-right",
			autoClose: 2500,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	const onSubmit = async (data) => {
		data["products"] = products.map(({ id }) => parseInt(id));
		console.log("ure", data);

		if (!data.products) {
			// setEditOpen(true);
			notify("Please select Products");
			return;
		}

		// let formData = new FormData();
		const formData = new FormData();
		let pproducts;
		if (Array.isArray(data["products"])) {
			pproducts = data["products"].map((p) => parseInt(p));
		} else {
			pproducts = parseInt(data["products"]);
		}
		console.log(pproducts);
		if (!data.owner) {
			const user = JSON.parse(localStorage.getItem("user"));
			data.owner = user.id;
		}
		for (const i in data) {
			if (i === "image") {
				console.log(i, data[i]);
				if (data[i].length) {
					const blob = await fetch(image).then((r) => r.blob());
					formData.append("file", blob, filename);
				}
			} else {
				formData.append(i, data[i]);
			}
		}
		if (selectedPopup?.id) {
			formData.append("popup", selectedPopup.id);
		}
		formData["products"] = [pproducts];
		formData["list_category"] = [data["list_category"]];
		console.log("Grape List form data");

		for (const [key, value] of formData.entries()) {
			console.log("FORM DATA:", key, value);
		}
		const res = isEdit
			? await UpdateGrapeList(formData, grapeList.id)
			: await Create(formData);

		if (res.success) {
			if (user?.user_type === 4) {
				navigate("/upload-playoff/grapelist");
			} else {
				navigate("/w86zjruk6q/grapelist");
			}

			// navigate("/w86zjruk6q/grapelist");
			// 	let newSellers = await getAllSeller();
			// 	setRows(newSellers.results);
			// 	setEditOpen(false);
		}
	};

	return (
		<>
			<Grid container justifyContent="center" spacing={2}>
				<ToastContainer />
				<Grid item xs={12} md={8}>
					<Box display="flex" pt={5} justifyContent="space-between">
						<Typography>
							{isEdit ? "Edit GrapeList" : "Add GrapeList"}
						</Typography>
					</Box>
					<Box pt={2} pb={5}>
						<FormWrapper onSubmit={handleSubmit(onSubmit)}>
							<Box mb={3}>
								<TextField
									fullWidth
									label="Enter List Name"
									error={!!errors.title}
									helperText={errors.title?.message}
									{...register("title", {
										required: "Enter List Name",
									})}
								/>
							</Box>

							<Box mb={3}>
								<TextField
									fullWidth
									multiline
									rows={4}
									label="Enter Description"
									error={!!errors.description}
									helperText={errors.description?.message}
									{...register("description", {
										required: "Enter Description",
									})}
								/>
							</Box>

							<Box mb={3}>
								<Controller
									name="list_category"
									control={control}
									rules={{
										required:
											"Please select at least one category",
									}}
									render={({ field }) => (
										<FormGroup row>
											{list.map((item) => (
												<FormControlLabel
													key={item.id}
													label={item.name}
													control={
														<Checkbox
															checked={field.value?.includes(
																item.id,
															)}
															onChange={(e) => {
																if (
																	e.target
																		.checked
																) {
																	field.onChange(
																		[
																			...field.value,
																			item.id,
																		],
																	);
																} else {
																	field.onChange(
																		field.value.filter(
																			(
																				id,
																			) =>
																				id !==
																				item.id,
																		),
																	);
																}
															}}
														/>
													}
												/>
											))}
										</FormGroup>
									)}
								/>
							</Box>

							<Box mb={3}>
								<FormControl error={!!errors.list_type}>
									<FormLabel>List Type</FormLabel>

									<Controller
										name="list_type"
										control={control}
										rules={{
											required:
												"Please select a list type",
										}}
										render={({ field }) => (
											<RadioGroup
												row
												{...field}
												value={field.value || ""}
											>
												{listOptions.map((option) => (
													<FormControlLabel
														key={option.value}
														value={option.value}
														control={<Radio />}
														label={option.title}
														disabled={isEdit}
													/>
												))}
											</RadioGroup>
										)}
									/>

									<FormHelperText>
										{errors.list_type?.message}
									</FormHelperText>
								</FormControl>
							</Box>
							{listType === "stylist_list" && (
								<Box mb={3}>
									<FormControl
										fullWidth
										error={!!errors.owner}
									>
										<InputLabel>Stylist</InputLabel>

										<Select
											label="Stylist"
											defaultValue=""
											{...register("owner", {
												required: "Select a stylist",
											})}
										>
											{stylelist.map((item) => (
												<MenuItem
													key={item.id}
													value={item.id}
												>
													{item.name}
												</MenuItem>
											))}
										</Select>

										<FormHelperText>
											{errors.owner?.message}
										</FormHelperText>
									</FormControl>
								</Box>
							)}

							<>
								<Box
									sx={{
										display: "flex",
										justifyContent: "flex-end",
										alignItems: "flex-end",
										gap: 2,
										marginBottom: 2,
									}}
								>
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-end",
											gap: 2,
										}}
									>
										{selectedPopup && (
											<Box>
												<Avatar
													variant="square"
													src={selectedPopup.image}
													alt={selectedPopup.title}
													sx={{
														width: 150,
														height: 150,
														objectFit: "fill",
													}}
												/>

												<Typography
													variant="body2"
													textAlign="center"
													mt={1}
												>
													{selectedPopup.title}
												</Typography>
											</Box>
										)}

										<Button
											type="button"
											onClick={handlePopupOpen}
											color="primary"
											variant="contained"
										>
											{selectedPopup
												? "Change Popup"
												: "Add Popup"}
										</Button>
									</Box>

									<FormControl error={Boolean(errors.image)}>
										{image && (
											<Avatar
												variant="square"
												src={image}
												sx={{
													width: 150,
													height: 150,
													objectFit: "fill",
													marginBottom: 2,
													marginX: "auto",
												}}
											/>
										)}

										<Button
											variant="contained"
											component="label"
											onChange={handleOnChange}
										>
											{!image ? "Upload " : "Change "}{" "}
											image
											<input
												hidden
												accept="image/*"
												id="file-upload"
												type="file"
												{...register("image")}
											/>
										</Button>
									</FormControl>
								</Box>
								<ImageCropper
									image={image}
									setImage={setImage}
									open={crop}
									setOpen={setCrop}
									aspect={1}
								/>
							</>

							<Box
								mb={3}
								display="flex"
								justifyContent="space-between"
							>
								<Typography variant="h6" gutterBottom>
									Products
								</Typography>
								<Box
									sx={{
										display: "flex",
										justifyContent: "space-between",
										gap: 2,
									}}
								>
									<Button
										type="button"
										onClick={handleOpen}
										color="primary"
										variant="contained"
									>
										{"Add Products From Playoffs"}
									</Button>

									<Button
										type="button"
										onClick={handleAdd}
										color="primary"
										variant="contained"
									>
										{"Add Products"}
									</Button>
								</Box>
							</Box>
							{products.length > 0 && (
								<Box my={3}>
									<Grid container spacing={2}>
										{products.map((item, i) => (
											<Grid
												item
												xs={12}
												md={2}
												key={`product-${i}`}
											>
												<Card
													sx={{
														height: "100%",
														display: "flex",
														justifyContent:
															"space-between",
														flexDirection: "column",
													}}
												>
													<CardMedia
														component="img"
														// height="194"
														image={item.image.file}
														alt="Paella dish"
													/>
													<CardContent>
														<Typography
															variant="body2"
															color="text.secondary"
														>
															{item.name}
														</Typography>
													</CardContent>
													<CardActions
														disableSpacing
														sx={{
															display: "flex",
															alignItems: "end",
														}}
													>
														<IconButton
															aria-label="delete product"
															onClick={() => {
																requestRemoveProduct(
																	item,
																);
																// setProducts(new_products)
															}}
														>
															<Delete />
														</IconButton>
													</CardActions>
												</Card>
											</Grid>
										))}
									</Grid>
								</Box>
							)}
							<Box mb={3}>
								<Button
									fullWidth
									type="submit"
									variant="contained"
								>
									{isEdit ? "Update" : "Save"}
								</Button>
							</Box>
						</FormWrapper>
						<Drawer
							anchor="right"
							open={editOpen}
							onClose={() => setEditOpen(false)}
						>
							<AddProductDrawer
								setEditOpen={setEditOpen}
								products={products}
								setProducts={setProducts}
							/>
						</Drawer>
					</Box>
				</Grid>
			</Grid>
			<AddPlayoffProductsDialog />
			<AddGrapeListPopupDialog />
			<DeleteProductDialog />
		</>
	);
};
